import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useRef, forwardRef, useMemo } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { NumericFormat } from "react-number-format";
import { Form } from "react-bootstrap";
import Select from "react-select";
import DataTableLayout from "layouts/DatatableLayout";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import "moment/locale/th"; // ใส่ locale ไทย
import { allSetUser } from "../../redux/handlers/manage/allSetUser.handler";
import { getReportSaleShop } from "../../redux/handlers/report/getReportSaleShop.handler";
import { getReportSaleShopDetail } from "../../redux/handlers/report/getReportSaleShopDetail.handler";
import { NumberFormat } from "utils/HelperFunction";
var summaryFields = [
    "jb_saleshop_reserveold",
    "jb_saleshop_reservenew",
    "jb_saleshop_netold",
    "jb_saleshop_netnew",
    "jb_saleshop_brttold",
    "jb_saleshop_brttnew"
];
export function ReportSalesNewStore() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState([]), 2), datalist = _useState[0], setDatalist = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), optionSales = _useState1[0], setOptionSales = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), salesId = _useState2[0], setSalesId = _useState2[1];
    var _useState3 = _sliced_to_array(useState(null), 2), month = _useState3[0], setMonth = _useState3[1];
    var getReportSaleShopReducer = useAppSelector(function(state) {
        return state.getReportSaleShopReducer;
    });
    // Load data
    useEffect(function() {
        dispatch(allSetUser({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, []);
    useEffect(function() {
        dispatch(getReportSaleShop({
            month: month ? moment(month).format("YYYY-MM") : "",
            saleid: parseInt(salesId)
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, [
        month,
        salesId
    ]);
    useEffect(function() {
        setIsLoading(getReportSaleShopReducer.isFetching);
        if (getReportSaleShopReducer.data) {
            var data = getReportSaleShopReducer.data.data;
            var all = [
                {
                    value: "",
                    label: "ทั้งหมด"
                }
            ];
            setDatalist(data);
            var arr = Array.from(new Map(data.map(function(ele) {
                var _ele_SaleUser;
                return [
                    ele === null || ele === void 0 ? void 0 : ele.jb_saleshop_saleid,
                    {
                        value: ele === null || ele === void 0 ? void 0 : ele.jb_saleshop_saleid,
                        label: ele === null || ele === void 0 ? void 0 : (_ele_SaleUser = ele.SaleUser) === null || _ele_SaleUser === void 0 ? void 0 : _ele_SaleUser.sys_user_fullname
                    }
                ];
            })).values());
            setOptionSales(_to_consumable_array(all).concat(_to_consumable_array(arr)));
        }
    }, [
        getReportSaleShopReducer
    ]);
    var totals = useMemo(function() {
        return Object.fromEntries(summaryFields.map(function(field) {
            return [
                field,
                datalist.reduce(function(sum, row) {
                    return sum + Number((row === null || row === void 0 ? void 0 : row[field]) || 0);
                }, 0)
            ];
        }));
    }, [
        datalist
    ]);
    var columns = [
        {
            name: "เดือน",
            selector: function(row) {
                return moment(row === null || row === void 0 ? void 0 : row.jb_saleshop_month).locale("th").format("MMMM YYYY");
            }
        },
        {
            name: "ชื่อเซลล์",
            selector: function(row) {
                var _row_SaleUser;
                return row === null || row === void 0 ? void 0 : (_row_SaleUser = row.SaleUser) === null || _row_SaleUser === void 0 ? void 0 : _row_SaleUser.sys_user_fullname;
            }
        },
        {
            name: "จำนวนใบจองเดิม",
            selector: function(row) {
                return row === null || row === void 0 ? void 0 : row.jb_saleshop_reserveold;
            },
            center: "true"
        },
        {
            name: "จำนวนใบจองใหม่",
            selector: function(row) {
                return row === null || row === void 0 ? void 0 : row.jb_saleshop_reservenew;
            },
            center: "true",
            // width: "180px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/report/reportsalesnewstore/detail/".concat(row === null || row === void 0 ? void 0 : row.jb_saleshop_month, "/").concat(row === null || row === void 0 ? void 0 : row.jb_saleshop_saleid),
                        children: row.jb_saleshop_reservenew ? row.jb_saleshop_reservenew : 0
                    })
                });
            }
        },
        {
            name: "ยอดเงินรวมใบจองเดิม",
            selector: function(row) {
                return row === null || row === void 0 ? void 0 : row.jb_saleshop_netold;
            },
            right: "true",
            width: "180px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    children: NumberFormat(row === null || row === void 0 ? void 0 : row.jb_saleshop_netold, 2)
                });
            }
        },
        {
            name: "ยอดเงินรวมใบจองใหม่",
            selector: function(row) {
                return row === null || row === void 0 ? void 0 : row.jb_saleshop_netnew;
            },
            right: "true",
            width: "180px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    children: NumberFormat(row === null || row === void 0 ? void 0 : row.jb_saleshop_netnew, 2)
                });
            }
        },
        {
            name: "จำนวนร้านเดิม",
            selector: function(row) {
                return row === null || row === void 0 ? void 0 : row.jb_saleshop_brttold;
            },
            center: "true"
        },
        {
            name: "จำนวนร้านใหม่",
            selector: function(row) {
                return row === null || row === void 0 ? void 0 : row.jb_saleshop_brttnew;
            },
            center: "true"
        }
    ];
    var footerHtml = function() {
        return /*#__PURE__*/ _jsx("div", {
            "aria-label": "ยอดรวม",
            style: {
                borderTop: "1px solid #e4e4e4",
                backgroundColor: "#f8f9fa"
            },
            children: /*#__PURE__*/ _jsx("div", {
                style: {
                    display: "flex",
                    minWidth: 960,
                    minHeight: 52,
                    alignItems: "center",
                    fontWeight: "bold"
                },
                children: columns.map(function(column, index) {
                    return /*#__PURE__*/ _jsx("div", {
                        "aria-label": column.name,
                        style: {
                            flex: column.width ? "0 0 ".concat(column.width) : "1 0 100px",
                            padding: "10px 15px",
                            textAlign: column.right ? "right" : column.center ? "center" : "left"
                        },
                        children: index === 1 ? "ยอดรวม" : index >= 2 ? NumberFormat(totals[summaryFields[index - 2]], column.right ? 2 : 0) : ""
                    }, column.name);
                })
            })
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7 text-decoration-none",
                                        children: "รายงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7 text-decoration-none",
                                        children: "รายงานเซลล์เปิดร้านใหม่"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "รายงานเซลล์เปิดร้านใหม่"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "card card-st-3 mb-3",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "card-body px-xl-3 pb-0",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "row gx-xl-4",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-6",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3 p-0",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1 z-3",
                                                children: "ค้นหาเดือน"
                                            }),
                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                selected: month,
                                                onChange: function(date) {
                                                    return setMonth(date);
                                                },
                                                dateFormat: "yyyy-MM",
                                                showMonthYearPicker: true,
                                                className: "form-control px-2 mb-2 input-equal",
                                                isClearable: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-6",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1 z-3",
                                                children: "ค้นหาเซลล์"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                className: "w-100 select-st-3 z-2",
                                                placeholder: "ค้นหาเซลล์",
                                                options: optionSales,
                                                value: optionSales.find(function(opt) {
                                                    return opt.value === salesId;
                                                }) || "",
                                                onChange: function(e) {
                                                    return setSalesId(e ? e.value : "");
                                                },
                                                isClearable: true
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "card-body p-0",
                        style: {
                            overflowX: "auto"
                        },
                        children: /*#__PURE__*/ _jsx("div", {
                            style: {
                                minWidth: 960
                            },
                            children: /*#__PURE__*/ _jsx(DataTableLayout, {
                                item: datalist,
                                columns: columns,
                                isSelectRows: false,
                                PerPage: 10,
                                footer: footerHtml,
                                responsive: false
                            })
                        })
                    })
                ]
            })
        ]
    });
}
export function ReportSalesNewStoreDetail() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState([]), 2), datalist = _useState[0], setDatalist = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), nameSales = _useState1[0], setNameSales = _useState1[1];
    var _useState2 = _sliced_to_array(useState({}), 2), footerData = _useState2[0], setFooterData = _useState2[1];
    var param = useParams();
    var dateMonth = useMemo(function() {
        return param.dateMonth ? param.dateMonth : null;
    }, [
        param.dateMonth
    ]);
    var saleId = useMemo(function() {
        return param.saleId ? param.saleId : null;
    }, [
        param.saleId
    ]);
    var getReportSaleShopDetailReducer = useAppSelector(function(state) {
        return state.getReportSaleShopDetailReducer;
    });
    useEffect(function() {
        dispatch(getReportSaleShopDetail({
            month: dateMonth,
            saleid: parseInt(saleId)
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, [
        saleId,
        dateMonth
    ]);
    useEffect(function() {
        setIsLoading(getReportSaleShopDetailReducer.isFetching);
        if (getReportSaleShopDetailReducer.data) {
            var _getReportSaleShopDetailReducer_data_data, _getReportSaleShopDetailReducer_data, _getReportSaleShopDetailReducer_data_data1, _getReportSaleShopDetailReducer_data1, _getReportSaleShopDetailReducer_data_data2, _getReportSaleShopDetailReducer_data2;
            setDatalist(getReportSaleShopDetailReducer === null || getReportSaleShopDetailReducer === void 0 ? void 0 : (_getReportSaleShopDetailReducer_data = getReportSaleShopDetailReducer.data) === null || _getReportSaleShopDetailReducer_data === void 0 ? void 0 : (_getReportSaleShopDetailReducer_data_data = _getReportSaleShopDetailReducer_data.data) === null || _getReportSaleShopDetailReducer_data_data === void 0 ? void 0 : _getReportSaleShopDetailReducer_data_data.list);
            setFooterData(getReportSaleShopDetailReducer === null || getReportSaleShopDetailReducer === void 0 ? void 0 : (_getReportSaleShopDetailReducer_data1 = getReportSaleShopDetailReducer.data) === null || _getReportSaleShopDetailReducer_data1 === void 0 ? void 0 : (_getReportSaleShopDetailReducer_data_data1 = _getReportSaleShopDetailReducer_data1.data) === null || _getReportSaleShopDetailReducer_data_data1 === void 0 ? void 0 : _getReportSaleShopDetailReducer_data_data1.summary);
            setNameSales(getReportSaleShopDetailReducer === null || getReportSaleShopDetailReducer === void 0 ? void 0 : (_getReportSaleShopDetailReducer_data2 = getReportSaleShopDetailReducer.data) === null || _getReportSaleShopDetailReducer_data2 === void 0 ? void 0 : (_getReportSaleShopDetailReducer_data_data2 = _getReportSaleShopDetailReducer_data2.data) === null || _getReportSaleShopDetailReducer_data_data2 === void 0 ? void 0 : _getReportSaleShopDetailReducer_data_data2.list[0].rs_reserve_salename);
        }
    }, [
        getReportSaleShopDetailReducer
    ]);
    var columns = [
        {
            name: "รหัสใบจอง",
            selector: function(row) {
                return row === null || row === void 0 ? void 0 : row.rs_reserve_code;
            },
            center: "true"
        },
        {
            name: "วันทำรายการ",
            selector: function(row) {
                return moment(row === null || row === void 0 ? void 0 : row.rs_reserve_approvedate).format("DD/MM/YYYY");
            },
            center: "true"
        },
        {
            name: "ร้านค้า",
            selector: function(row) {
                return row === null || row === void 0 ? void 0 : row.rs_reserve_shopname;
            },
            center: "true"
        },
        {
            name: "จำนวนสินค้า (ชิ้น)",
            selector: function(row) {
                return row === null || row === void 0 ? void 0 : row.rs_reserve_amount;
            },
            right: "true"
        },
        {
            name: "จำนวนเงิน",
            selector: function(row) {
                return row.rs_reserve_net;
            },
            right: "true",
            cell: function(row) {
                return /*#__PURE__*/ _jsx("div", {
                    children: NumberFormat(row.rs_reserve_net, 2)
                });
            }
        },
        {
            name: "จำนวนสินค้าจริง (ชิ้น)",
            selector: function(row) {
                return (row === null || row === void 0 ? void 0 : row.rs_reserve_stamount) || 0;
            },
            right: "true"
        },
        {
            name: "จำนวนเงินจริง",
            selector: function(row) {
                return row.rs_reserve_net;
            },
            // center: "true",
            right: "true",
            cell: function(row) {
                return /*#__PURE__*/ _jsx("div", {
                    children: NumberFormat(row.rs_reserve_stnet || 0, 2)
                });
            }
        }
    ];
    var footerHtml = function() {
        return /*#__PURE__*/ _jsx("div", {
            style: {
                borderTop: "1px solid #e4e4e4",
                backgroundColor: "#f8f9fa"
            },
            children: /*#__PURE__*/ _jsxs("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    minHeight: "52px",
                    padding: "0px 16px"
                },
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            flex: "1 1 0",
                            minWidth: 0
                        }
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            flex: "1 1 0",
                            minWidth: 0
                        }
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            flex: "1 1 0",
                            minWidth: 0,
                            padding: "0px 16px"
                        },
                        children: "ผลรวม"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            flex: "1 1 0",
                            minWidth: 0,
                            textAlign: "right",
                            fontWeight: "bold",
                            padding: "0px 10px"
                        },
                        children: footerData.rs_reserve_amount || 0
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            flex: "1 1 0",
                            minWidth: 0,
                            textAlign: "right",
                            fontWeight: "bold",
                            padding: "0px 10px"
                        },
                        children: footerData.rs_reserve_net ? NumberFormat(footerData.rs_reserve_net, 2) : "0.00"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            flex: "1 1 0",
                            minWidth: 0,
                            textAlign: "right",
                            fontWeight: "bold",
                            padding: "0px 15px"
                        },
                        children: footerData.rs_reserve_stamount || 0
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            flex: "1 1 0",
                            minWidth: 0,
                            textAlign: "right",
                            fontWeight: "bold"
                        },
                        children: footerData.rs_reserve_stnet ? NumberFormat(footerData.rs_reserve_stnet, 2) : "0.00"
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "pagezoom",
                children: /*#__PURE__*/ _jsx("nav", {
                    "aria-label": "breadcrumb",
                    className: "mt-2",
                    children: /*#__PURE__*/ _jsxs("ol", {
                        className: "breadcrumb fs-16 ps-0 mb-1",
                        children: [
                            /*#__PURE__*/ _jsx("li", {
                                className: "breadcrumb-item",
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: "#",
                                    className: "tc-7 text-decoration-none",
                                    children: "รายงาน"
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                className: "breadcrumb-item",
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: "#",
                                    className: "tc-7 text-decoration-none",
                                    children: "รายงานเซลล์เปิดร้านใหม่"
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                className: "breadcrumb-item",
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: "#",
                                    className: "tc-7 text-decoration-none",
                                    children: "รายละเอียดใบจอง"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "card card-st-3 mb-3",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "card-body px-xl-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "pagezoom m-3 p-3",
                            style: {
                                border: "1px solid #e4e4e4",
                                borderRadius: 10
                            },
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "fs-24 mb-4",
                                    children: "รายละเอียดใบจอง"
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "fs-20",
                                    children: [
                                        "เซลล์ : ",
                                        nameSales
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "card-body p-0",
                        children: /*#__PURE__*/ _jsx(DataTableLayout, {
                            item: datalist,
                            columns: columns,
                            isSelectRows: false,
                            PerPage: 10,
                            showFooter: true,
                            footer: footerHtml
                        })
                    })
                ]
            })
        ]
    });
}
